import React from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Link from '@atlaskit/link';
import { Stack, Text } from '@atlaskit/primitives';
import { getAdminBaseUrl } from '@atlassian/jira-external-urls/src/utils/get-admin-base-url/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import messages from './messages';

type UpgradePlanContentProps = {
	feature: 'problemManagement' | 'changeManagement' | 'postIncidentReview';
};

const buildUTMParameters = (feature: UpgradePlanContentProps['feature']) =>
	new URLSearchParams({
		utm_campaign: 'JSM-repackaging-upsells',
		utm_source: 'features-page',
		utm_medium: 'product',
		utm_content: `${feature}-toggle`,
	});

export const UpgradePlanContent = ({ feature }: UpgradePlanContentProps) => {
	const { formatMessage } = useIntl();
	const cloudId = useCloudId();

	const handleLinkClick = (_: React.MouseEvent, analyticEvent: UIAnalyticsEvent) => {
		// https://data-portal.internal.atlassian.com/analytics/registry/71212
		fireUIAnalytics(analyticEvent, 'featureTilePaymentPopoverCta', { feature });
	};

	return (
		<Stack space="space.100">
			<Text>{formatMessage(messages.description)}</Text>
			<Link
				href={`${getAdminBaseUrl()}/s/${cloudId}/billing/applications/change-edition/jira-servicedesk.ondemand?${buildUTMParameters(feature)}`}
				target="_blank"
				onClick={handleLinkClick}
				onMouseDown={(e) => {
					e.preventDefault();
				}}
			>
				{formatMessage(messages.ctaLink)}
			</Link>
		</Stack>
	);
};
